// extracted by mini-css-extract-plugin
export default {"tr":"TableRow_tr__gUB9H","td":"TableRow_td__SkrUM"};